import React from 'react'
import { connect } from 'react-fela'
import { NavLink } from 'react-router-dom'
import AvatarUser from 'views/components/smart/AvatarUser'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'
import PropTypes from 'prop-types'

const NavBarDropdown = (props) => {
  const { styles, links } = props
  return (
    <div className={styles.dropdown}>
      <div className={styles.dropdownTrigger}>
        <AvatarUser />
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="24" viewBox="0 0 24 24" width="24">
          <path d="M7 10l5 5 5-5z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </div>
      <ul className={styles.dropdownTarget}>
        {links.map((link, index) => (
          <li key={index} className={styles.dropdownItem}>
            <NavLink className={styles.dropdownLink} to={link.href}>
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  )
}

const rules = {
  dropdownItem: () => ({
    color: ds.get('colors.magneticBlack'),
    ':hover': {
      backgroundColor: ds.get('colors.greyLighter'),
    },
  }),
  dropdownLink: () => ({
    display: 'block',
    padding: pxTo(10, ds.get('type.baseFontSize'), 'em'),
    width: '100%',
    height: '100%',
    textDecoration: 'none',
    color: 'currentColor',
  }),
  dropdownTarget: () => ({
    display: 'none',
    position: 'absolute',
    top: pxTo(50, ds.get('type.baseFontSize'), 'rem'),
    left: 0,
    transform: `translateX(-${pxTo(165, ds.get('type.baseFontSize'), 'rem')})`,
    minWidth: pxTo(220, ds.get('type.baseFontSize'), 'rem'),
    zIndex: ds.get('zIndex.dropdowns'),
    backgroundColor: ds.get('colors.white'),
    listStyle: 'none',
    padding: 0,
    margin: 0,
    boxShadow: `
      0
      ${pxTo(2, ds.get('type.baseFontSize'), 'rem')}
      ${pxTo(8, ds.get('type.baseFontSize'), 'rem')}
      0
      rgba(0,0,0,0.1)`,
  }),
  dropdownTrigger: () => ({
    display: 'flex',
    alignItems: 'center',
  }),
  dropdown: () => ({
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer',
    paddingBottom: pxTo(15, ds.get('type.baseFontSize'), 'rem'),
    marginBottom: pxTo(-15, ds.get('type.baseFontSize'), 'rem'),
    textAlign: 'left',
    ':hover ul': {
      display: 'block',
    },
    ':focus ul': {
      display: 'block',
    },
    ':focus-within': {
      cursor: 'pointer',
    },
  }),
}

NavBarDropdown.propTypes = {
  styles: PropTypes.object.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

export default connect(rules)(NavBarDropdown)
